import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Addunitebutton from "../components/addunitebutton";
import remove from "../assets/remove.png";

const Createformation = () => {
  const [titre, settitre] = useState("");
  const [description, setdescription] = useState("");
  const [overview, setoverview] = useState("");
  const [image, setimage] = useState("");
  const [price, setprice] = useState(0);
  const [unites, setunites] = useState([]);
  const [order, setorder] = useState(0); // new state variable
  const [topics, settopics] = useState([]);
  const [onetopic, setonetopic] = useState({ name: "select topic", id: 0 });
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message
  const [refresh, setRefresh] = useState(false); // new state variable

  const navigate = useNavigate();

  const handelshooseTopic = (e) => {
    setonetopic(e);
  };

  const gettopics = async () => {
    let responce;
    try {
      responce = await axios.get(
        "https://pfebackend-zbz0.onrender.com/api/topics/"
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    settopics(responce.data);
  };

  useEffect(() => {
    gettopics();
  }, []);

  const handleAddVideoResource = (index) => (event) => {
    unites[index].videos.push({
      video: event.target.files[0],
      order: order,
      type: "video",
      name: event.target.files[0].name,
      free: false,
    });
    setorder(order + 1);
    setunites(unites);
    setRefresh(!refresh); // toggle the value to trigger a refresh
  };

  const handleAddFileResource = (index) => (event) => {
    unites[index].files.push({
      file: event.target.files[0],
      order: order,
      type: "file",
      name: event.target.files[0].name,
      free: false,
    });
    setorder(order + 1);
    setunites(unites);
    setRefresh(!refresh); // toggle the value to trigger a refresh
  };

  const handleAddtext = (index) => {
    unites[index].texts.push({
      text: "",
      order: order,
      type: "text",
      name: "no name yet",
      free: false,
    });
    setorder(order + 1);
    setunites(unites);
    setRefresh(!refresh); // toggle the value to trigger a refresh
  };

  const handeltitrechange = (e) => {
    settitre(e.target.value);
  };

  const handelpricechange = (e) => {
    setprice(e.target.value);
  };

  const handeladdunite = () => {
    setunites([
      ...unites,
      { formation: "", name: "", videos: [], files: [], texts: [] },
    ]);
  };

  const handelunitename = (evt, e, index) => {
    unites[index].name = evt.target.value;
    setunites(unites);
  };

  const handleAddResource = (index, type) => {
    document.getElementById(`${index}-${type}`).click();
  };

  const handeladdtext = (evt, t) => {
    t.text = evt.target.value;
    t.name = evt.target.value.substring(0, 10);
    setRefresh(!refresh); // toggle the value to trigger a refresh
  };

  const mergeArrays = (array1, array2, array3) => {
    const combinedArray = [];

    // combine all the elements from the three arrays into a single array
    array1.forEach((element) => {
      combinedArray[element.order] = element;
    });

    array2.forEach((element) => {
      combinedArray[element.order] = element;
    });

    array3.forEach((element) => {
      combinedArray[element.order] = element;
    });

    // filter out any undefined elements (in case there were gaps in the order)
    return combinedArray.filter((element) => element !== undefined);
  };

  function sortByOrder(...arrays) {
    const combinedPeople = arrays.flat();
    return combinedPeople.sort((a, b) => a.order - b.order);
  }

  const handelsubmit = async (e) => {
    e.preventDefault();
    for (let i = 0; i < unites.length; i++) {
      unites[i].formation = titre;
      if (unites[i].name === "") {
        setErrorMessage(
          `the form was not send, please add a name for the uite number ${
            i + 1
          } `
        );
        return;
      }
    }
    // console.log(unites);

    if (titre === "") {
      setErrorMessage("the form was not send, please add a title");
      return;
    }
    if (description === "") {
      setErrorMessage("the form was not send, please add a description");
      return;
    }
    if (overview === "") {
      setErrorMessage("the form was not send, please add a overview");
      return;
    }

    if (onetopic.name === "select topic") {
      setErrorMessage("the form was not send, please select a topic");
      return;
    }

    if (!image) {
      setErrorMessage(
        "the form was not send, please  please add a cover image"
      );
      return;
    }

    const gereralformData = new FormData();
    gereralformData.append("file", image);
    gereralformData.append("name", titre);
    gereralformData.append("description", description);
    gereralformData.append("topic", onetopic.id);
    gereralformData.append("overview", overview);
    gereralformData.append("price", price);

    let responce1;
    try {
      responce1 = await axios.post(
        "https://pfebackend-zbz0.onrender.com/api/formations/add/",
        gereralformData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }

    for (let i = 0; i < unites.length; i++) {
      const { data: data2 } = await axios.post(
        "https://pfebackend-zbz0.onrender.com/api/unites/add/",
        {
          name: unites[i].name,
          formation_id: responce1.data.id,
        }
      );

      for (let j = 0; j < unites[i].videos.length; j++) {
        const formData = new FormData();
        formData.append("file", unites[i].videos[j].video);
        formData.append("unitid", data2.id);
        formData.append("order", unites[i].videos[j].order);
        formData.append("type", unites[i].videos[j].type);
        formData.append("name", unites[i].videos[j].name);
        formData.append("free", unites[i].videos[j].free);

        await axios.post(
          "https://pfebackend-zbz0.onrender.com/api/video/add/",
          formData,
          {}
        );
      }
      for (let j = 0; j < unites[i].files.length; j++) {
        const formData2 = new FormData();
        formData2.append("file", unites[i].files[j].file);
        formData2.append("unitid", data2.id);
        formData2.append("order", unites[i].files[j].order);
        formData2.append("type", unites[i].files[j].type);
        formData2.append("name", unites[i].files[j].name);
        formData2.append("free", unites[i].files[j].free);

        await axios.post(
          "https://pfebackend-zbz0.onrender.com/api/file/add/",
          formData2,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
      for (let j = 0; j < unites[i].texts.length; j++) {
        const formData3 = new FormData();
        formData3.append("text", unites[i].texts[j].text);
        formData3.append("unitid", data2.id);
        formData3.append("order", unites[i].texts[j].order);
        formData3.append("type", unites[i].texts[j].type);
        formData3.append("name", unites[i].texts[j].name);
        formData3.append("free", unites[i].texts[j].free);

        const { data: data5 } = await axios.post(
          "https://pfebackend-zbz0.onrender.com/api/text/add/",
          formData3,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
    }
    navigate("/");
  };

  const handleAddPicture = (e) => {
    setimage(e.target.files[0]);
  };

  const handeldescriptionchange = (e) => {
    setdescription(e.target.value);
  };
  const handeloverviewchange = (e) => {
    setoverview(e.target.value);
  };

  const handleDeleteUnite = (index) => {
    unites.splice(index, 1);
    setunites(unites);
    setRefresh(!refresh); // toggle the value to trigger a refresh
  };

  const handleDeletevideo = (index, unitIndex) => {
    unites[unitIndex].videos.splice(index, 1);
    setunites(unites);
    setRefresh(!refresh); // toggle the value to trigger a refresh
  };
  const handleDeletefile = (index, unitIndex) => {
    unites[unitIndex].files.splice(index, 1);
    setunites(unites);
    setRefresh(!refresh); // toggle the value to trigger a refresh
  };

  const handleDeletetext = (index, unitIndex) => {
    unites[unitIndex].texts.splice(index, 1);
    setunites(unites);
    setRefresh(!refresh); // toggle the value to trigger a refresh
  };

  const handeltogle = () => {
    const dropdown = document.getElementById("bttngrp88");
    dropdown.classList.add("displayblock");

    const button = document.getElementById("btn-filter22");

    document.addEventListener("click", function (event) {
      if (event.target !== button && !button.contains(event.target)) {
        dropdown.classList.remove("displayblock");
      }
    });
  };

  const handelradioclick = (evt, r) => {
    r.free = evt.target.checked;
    setRefresh(!refresh);
  };

  return (
    <form className="createroom-container">
      <h2>Create a new training</h2>
      {errorMessage && <div className=" erroremailexiste">{errorMessage}</div>}

      <div className="create-training-staticinfo">
        <div className="input-formation-title">
          <label htmlFor="formation_titre">training title</label>
          <input
            name="formation_titre"
            required
            onInput={(e) => handeltitrechange(e)}
            type="text"
            id="formation_titre"
            className="forum-creation-input"
          />
        </div>
        <div className="input-formation-description">
          <label htmlFor="formation_description"> description</label>
          <textarea
            className="create-room-textarea"
            name="description"
            required
            id="formation_description"
            onInput={(e) => handeldescriptionchange(e)}
          ></textarea>
        </div>
        <div className="input-formation-overview">
          <label htmlFor="formation_overview"> overview</label>
          <textarea
            className="create-room-textarea"
            name="overview"
            required
            id="formation_overview"
            onInput={(e) => handeloverviewchange(e)}
          ></textarea>
        </div>
        <div className="input-formation-picture">
          <label className="pic-lable" htmlFor="formation_pic">
            {" "}
            picture
          </label>
          <input
            name="picture"
            required
            type="file"
            id="formation_pic"
            onChange={(e) => handleAddPicture(e)}
          />
        </div>
        <div className="input-formation-category">
          <div className="pull-left course-filter">
            <div className="filter-label">Category:</div>
            <button
              onClick={handeltogle}
              id="btn-filter22"
              className="btn-filter dropdown-toggle"
              type="button"
            >
              {onetopic.name} <span className="caret"></span>
            </button>
            <div id="bttngrp88" className=" displaynone btn-group">
              <ul
                className="dropdown-menu-create-training"
                role="menu"
                id="filter-dropdown"
              >
                {topics.map((e, i) => {
                  return (
                    <li key={i} className="filter-item">
                      <div onClick={() => handelshooseTopic(e)}>{e.name}</div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        <div className="input-formation-price">
          <label htmlFor="formation_price"> price</label>
          <input
            name="price"
            required
            onInput={(e) => handelpricechange(e)}
            type="number"
            id="formation_price"
            className="forum-creation-input"
          />
        </div>

        <Addunitebutton handeladdunite={handeladdunite} />
      </div>

      {unites.map((e, unitIndex) => {
        return (
          <div className="unite-container" key={unitIndex}>
            <div className="unite-title-container">
              <label className="unitetitle-lable" htmlFor={`unite${unitIndex}`}>
                unite title
              </label>
              <input
                name={`unite${unitIndex}`}
                required
                onInput={(evt) => handelunitename(evt, e, unitIndex)}
                type="text"
                id={`unite${unitIndex}`}
                className="forum-creation-input unitetitle"
              />
            </div>

            <div className="buttonscontainer">
              <div
                className=" delete "
                onClick={() => handleDeleteUnite(unitIndex)}
              >
                Delete
              </div>

              <div
                className="coco"
                onClick={() => handleAddResource(unitIndex, "video")}
              >
                Add Video
              </div>
              <input
                name={`video-${unitIndex}`}
                required
                type="file"
                id={`${unitIndex}-video`}
                accept="video/*"
                onChange={handleAddVideoResource(unitIndex)}
                style={{ display: "none" }}
              />
              <div
                className="coco"
                onClick={() => handleAddResource(unitIndex, "file")}
              >
                Add File
              </div>
              <input
                name={`file-${unitIndex}`}
                required
                type="file"
                id={`${unitIndex}-file`}
                accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff"
                onChange={handleAddFileResource(unitIndex)}
                style={{ display: "none" }}
              />
              <div
                className="coco"
                onClick={() => handleAddtext(unitIndex, "text")}
              >
                Add text
              </div>
            </div>

            {sortByOrder(e.videos, e.files, e.texts).map((r, index) => {
              if (r.type === "video") {
                return (
                  <div className="container-creation" key={index}>
                    <div className="radio-container">
                      <input
                        onClick={(evt) => handelradioclick(evt, r)}
                        className="radio-button"
                        type="checkbox"
                      />
                      <label htmlFor="">free</label>
                    </div>

                    <video className="video-creation" controls>
                      <source src={URL.createObjectURL(r.video)} />
                    </video>
                    <div
                      className="delete-creation"
                      onClick={() =>
                        handleDeletevideo(e.videos.indexOf(r), unitIndex)
                      }
                    >
                      <img src={remove} alt="" />
                    </div>
                  </div>
                );
              } else {
                if (r.type === "file") {
                  return (
                    <div className="container-creation" key={index}>
                      <div className="radio-container">
                        <input
                          onClick={(evt) => handelradioclick(evt, r)}
                          className="radio-button"
                          type="checkbox"
                        />
                        <label htmlFor="">free</label>
                      </div>
                      <a
                        className="custom-link"
                        href={URL.createObjectURL(r.file)}
                      >
                        {r.file.name}
                      </a>
                      <div
                        className="delete-creation"
                        onClick={() =>
                          handleDeletefile(e.files.indexOf(r), unitIndex)
                        }
                      >
                        <img src={remove} alt="" />
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div className="container-creation" key={index}>
                      <div className="radio-container">
                        <input
                          onClick={(evt) => handelradioclick(evt, r)}
                          className="radio-button"
                          type="checkbox"
                        />
                        <label htmlFor="">free</label>
                      </div>
                      <textarea
                        className="create-room-textarea"
                        name={`${index}-text-${unitIndex}`}
                        required
                        onInput={(evt) => handeladdtext(evt, r)}
                      ></textarea>

                      <div
                        className="delete-creation"
                        onClick={() =>
                          handleDeletetext(e.texts.indexOf(r), unitIndex)
                        }
                      >
                        <img src={remove} alt="" />
                      </div>
                    </div>
                  );
                }
              }
            })}
          </div>
        );
      })}
      <button className="creation-submition" onClick={handelsubmit}>
        submit
      </button>
    </form>
  );
};

export default Createformation;
